import { OWebPageBase, OWebLogout, OWebRouteContext } from "oweb";
import app from "@/app";
import PUserLogoutComponent from "@/components/pages/oweb/PUserLogout.vue";
import { VueConstructor } from 'vue';

export default class PUserLogout extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserLogout"
	}

	getRoutes() {
		return [ {
			title: "OO_LANG_LOGOUT",
			path: "/logout",
			icon: "fa-power-off"
		} ]
	}

	onOpen(context: OWebRouteContext) {

		if (!app.userVerified()) {
			return app.showHomePage();
		}

		let logout = new OWebLogout(app);
		logout.onSuccess(function () {
			setTimeout(function () {
				app.destroyApp();
			});
		}).onError(function (response) {
			app.view.dialog(response);
			app.router.goBack();
		}).logout();
	}
	getComponent() {
		return PUserLogoutComponent;
	}
}